import { render } from "./EvidenceScreenshotButton.vue?vue&type=template&id=32770ed4"
import script from "./EvidenceScreenshotButton.vue?vue&type=script&lang=js"
export * from "./EvidenceScreenshotButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__